export const preConfiguredThemesV2 = {
    orange: {
        headerColorFirst: "#FFA500", //header
        headerColorSecond: "#FF8C00", // Header Section Color 2
        backgroundColorFirst: "#FFF8E7", // Background Color 1
        backgroundColorSecond: "#FFDAB9", // Background Color 2
        textColor: "#000000", //genel yazı
        errorColor: "#FF4500", //error color
        representativeBubbleColor: "#FFA500", // temsilci balon rengi
        representativeTextColor: "#FFFFFF", //temsilci konuşma rengi
        customerBubbleColor: "#FFA500", //ziyaretci balon rengi
        customerTextColor: "#FFF", // ziyaretçi yazı rengi
        buttonColor: "#FFA500", //buton rengi
        headerTextColor: "#FFFFFF", //header yazı rengi
        formColorText: "#000000", //form yazı rengi
        chatBotButtonText: "#FFA500", //chatbot buton yazı rengi
        chatBotButtonColor: "transparent", //chatbot buton rengi
    },
    black: {
        headerColorFirst: "#333333", //header
        headerColorSecond: "#555555", // Header Section Color 2
        backgroundColorFirst: "#777777", // Background Color 1
        backgroundColorSecond: "#999999", // Background Color 2
        textColor: "#FFFFFF", //genel yazı
        errorColor: "#FF0000", //error color
        representativeBubbleColor: "#555555", // temsilci balon rengi
        representativeTextColor: "#FFFFFF", //temsilci konuşma rengi
        customerBubbleColor: "#AAAAAA", //ziyaretci balon rengi
        customerTextColor: "#FFF", // ziyaretçi yazı rengi
        buttonColor: "#555555", //buton rengi
        headerTextColor: "#FFFFFF", //header yazı rengi
        formColorText: "#FFFFFF", //form yazı rengi
        chatBotButtonText: "#555555", //chatbot buton yazı rengi
        chatBotButtonColor: "transparent", //chatbot buton rengi
    },
    blue: {
        headerColorFirst: "#004080", //header
        headerColorSecond: "#0066CC", // Header Section Color 2
        backgroundColorFirst: "#E6F2FF", // Background Color 1
        backgroundColorSecond: "#B3D9FF", // Background Color 2
        textColor: "#000000", //genel yazı
        errorColor: "#FF0000", //error color
        representativeBubbleColor: "#0066CC", // temsilci balon rengi
        representativeTextColor: "#FFFFFF", //temsilci konuşma rengi
        customerBubbleColor: "#66B2FF", //ziyaretci balon rengi
        customerTextColor: "#FFF", // ziyaretçi yazı rengi
        buttonColor: "#0066CC", //buton rengi
        headerTextColor: "#FFFFFF", //header yazı rengi
        formColorText: "#000000", //form yazı rengi
        chatBotButtonText: "#0066CC", //chatbot buton yazı rengi
        chatBotButtonColor: "transparent", //chatbot buton rengi
    },
    green: {
        headerColorFirst: "#008000", //header
        headerColorSecond: "#006400", // Header Section Color 2
        backgroundColorFirst: "#E6FFE6", // Background Color 1
        backgroundColorSecond: "#C2FFC2", // Background Color 2
        textColor: "#000000", //genel yazı
        errorColor: "#FF0000", //error color
        representativeBubbleColor: "#006400", // temsilci balon rengi
        representativeTextColor: "#FFFFFF", //temsilci konuşma rengi
        customerBubbleColor: "#009900", //ziyaretci balon rengi
        customerTextColor: "#FFF", // ziyaretçi yazı rengi
        buttonColor: "#006400", //buton rengi
        headerTextColor: "#FFFFFF", //header yazı rengi
        formColorText: "#000000", //form yazı rengi
        chatBotButtonText: "#006400", //chatbot buton yazı rengi
        chatBotButtonColor: "transparent", //chatbot buton rengi
    },
    purple: {
        headerColorFirst: "#6A0DAD", //header
        headerColorSecond: "#8A14B7", // Header Section Color 2
        backgroundColorFirst: "#4B0082", // Background Color 1
        backgroundColorSecond: "#6C2EAC", // Background Color 2
        textColor: "#FFFFFF", //genel yazı
        errorColor: "#FF0000", //error color
        representativeBubbleColor: "#8A14B7", // temsilci balon rengi
        representativeTextColor: "#FFFFFF", //temsilci konuşma rengi
        customerBubbleColor: "#9B4FA9", //ziyaretci balon rengi
        customerTextColor: "#FFFFFF", // ziyaretçi yazı rengi
        buttonColor: "#8A14B7", //buton rengi
        headerTextColor: "#FFFFFF", //header yazı rengi
        formColorText: "#FFFFFF", //form yazı rengi
        chatBotButtonText: "#8A14B7", //chatbot buton yazı rengi
        chatBotButtonColor: "transparent", //chatbot buton rengi
    },
    red: {
        headerColorFirst: "#FF0000", //header
        headerColorSecond: "#FF3333", // Header Section Color 2
        backgroundColorFirst: "#FFCDD2", // Background Color 1
        backgroundColorSecond: "#FFA4A9", // Background Color 2
        textColor: "#000000", //genel yazı
        errorColor: "#FF0000", //error color
        representativeBubbleColor: "#FF3333", // temsilci balon rengi
        representativeTextColor: "#FFFFFF", //temsilci konuşma rengi
        customerBubbleColor: "#FF6666", //ziyaretci balon rengi
        customerTextColor: "#FFF", // ziyaretçi yazı rengi
        buttonColor: "#FF3333", //buton rengi
        headerTextColor: "#FFFFFF", //header yazı rengi
        formColorText: "#000000", //form yazı rengi
        chatBotButtonText: "#FF3333", //chatbot buton yazı rengi
        chatBotButtonColor: "transparent", //chatbot buton rengi
    },
    yellow: {
        headerColorFirst: "#FDB813", //header
        headerColorSecond: "#FFC20E", // Header Section Color 2
        backgroundColorFirst: "#FFF9E6", // Background Color 1
        backgroundColorSecond: "#FFECCC", // Background Color 2
        textColor: "#000000", //genel yazı
        errorColor: "#FF3333", //error color
        representativeBubbleColor: "#FFC20E", // temsilci balon rengi
        representativeTextColor: "#FFFFFF", //temsilci konuşma rengi
        customerBubbleColor: "#FFD94A", //ziyaretci balon rengi
        customerTextColor: "#FFF", // ziyaretçi yazı rengi
        buttonColor: "#FDB813", //buton rengi
        headerTextColor: "#FFFFFF", //header yazı rengi
        formColorText: "#000000", //form yazı rengi
        chatBotButtonText: "#FDB813", //chatbot buton yazı rengi
        chatBotButtonColor: "transparent", //chatbot buton rengi
    },
    pink: {
        headerColorFirst: "#FFC0CB", //header
        headerColorSecond: "#FFB6C1", // Header Section Color 2
        backgroundColorFirst: "#FFF0F5", // Background Color 1
        backgroundColorSecond: "#FFD6E7", // Background Color 2
        textColor: "#000000", //genel yazı
        errorColor: "#FF1493", //error color
        representativeBubbleColor: "#FFB6C1", // temsilci balon rengi
        representativeTextColor: "#FFFFFF", //temsilci konuşma rengi
        customerBubbleColor: "#FFC0CB", //ziyaretci balon rengi
        customerTextColor: "#FFF", // ziyaretçi yazı rengi
        buttonColor: "#FF69B4", //buton rengi
        headerTextColor: "#FFFFFF", //header yazı rengi
        formColorText: "#000000", //form yazı rengi
        chatBotButtonText: "#FF69B4", //chatbot buton yazı rengi
        chatBotButtonColor: "transparent", //chatbot buton rengi
    },
    gray: {
        headerColorFirst: "#333333", //header
        headerColorSecond: "#666666", // Header Section Color 2
        backgroundColorFirst: "#EFEFEF", // Background Color 1
        backgroundColorSecond: "#CCCCCC", // Background Color 2
        textColor: "#000000", //genel yazı
        errorColor: "#FF0000", //error color
        representativeBubbleColor: "#666666", // temsilci balon rengi
        representativeTextColor: "#FFFFFF", //temsilci konuşma rengi
        customerBubbleColor: "#999999", //ziyaretci balon rengi
        customerTextColor: "#FFF", // ziyaretçi yazı rengi
        buttonColor: "#666666", //buton rengi
        headerTextColor: "#FFFFFF", //header yazı rengi
        formColorText: "#000000", //form yazı rengi
        chatBotButtonText: "#666666", //chatbot buton yazı rengi
        chatBotButtonColor: "transparent", //chatbot buton rengi
    },
    mango: {
        headerColorFirst: "#FFB74D", //header
        headerColorSecond: "#FFA726", // Header Section Color 2
        backgroundColorFirst: "#FFF3E0", // Background Color 1
        backgroundColorSecond: "#FFCC80", // Background Color 2
        textColor: "#000000", //genel yazı
        errorColor: "#FF5722", //error color
        representativeBubbleColor: "#FFA726", // temsilci balon rengi
        representativeTextColor: "#FFFFFF", //temsilci konuşma rengi
        customerBubbleColor: "#FFA726", //ziyaretci balon rengi
        customerTextColor: "#FFF", // ziyaretçi yazı rengi
        buttonColor: "#FFA726", //buton rengi
        headerTextColor: "#FFFFFF", //header yazı rengi
        formColorText: "#000000", //form yazı rengi
        chatBotButtonText: "#FFA726", //chatbot buton yazı rengi
        chatBotButtonColor: "transparent", //chatbot buton rengi
    },
    servquick: {
        headerColorFirst: "#2C3E50", //header
        headerColorSecond: "#34495E", // Header Section Color 2
        backgroundColorFirst: "#ECF0F1", // Background Color 1
        backgroundColorSecond: "#DADFE1", // Background Color 2
        textColor: "#000000", //genel yazı
        errorColor: "#E74C3C", //error color
        representativeBubbleColor: "#34495E", // temsilci balon rengi
        representativeTextColor: "#FFFFFF", //temsilci konuşma rengi
        customerBubbleColor: "#85C1E9", //ziyaretci balon rengi
        customerTextColor: "#FFF", // ziyaretçi yazı rengi
        buttonColor: "#2980B9", //buton rengi
        headerTextColor: "#FFFFFF", //header yazı rengi
        formColorText: "#000000", //form yazı rengi
        chatBotButtonText: "#2980B9", //chatbot buton yazı rengi
        chatBotButtonColor: "transparent", //chatbot buton rengi
    },
};
